import React, {Fragment, useState} from "react";
import PropTypes from "prop-types";

import ICInput from "./form/input";

export const TAG_SPLITTER_REGEX = /\n|;|,/g;

const ICTagInput = props => {
  const [tagInputVal, setTagInputVal] = useState("");

  const handleInputChange = e => {
    setInputVal(e.target.value);
  };

  function setInputVal(val) {
    setTagInputVal(val);
    if (props.onInputChange) {
      props.onInputChange(val);
    }
  }

  const handleOnInputKeyUp = e => {
    if (trim(tagInputVal).length < 2) {
      setTagInputVal(tagInputVal);
      return;
    }

    if (e.key === "," || e.key === "Enter" || e.key === ";") {
      const newList = props.tags || [];
      const tagsToAdd = tagInputVal.split(TAG_SPLITTER_REGEX).filter(str =>!!str)
      for (const string of tagsToAdd) {
        if (!newList.includes(trim(string))) {
          newList.push(trim(string));
        }
      }
      setTagInputVal("");
      saveTags(newList);
    }
  };

  const handleOnInputKeyDown = e => {
    if ((e.key === "Backspace" || e.key === "Delete") &&
      tagInputVal !== undefined &&
      tagInputVal.trim().length === 0 &&
      props.tags?.length > 0
    ) {
      let newList = props.tags || [];
      newList = newList.filter((val, i) => {
        return i !== (props.tags || []).length - 1;
      });
      saveTags(newList);
    }
  };

  const removeSelTag = index => {
    let newList = props.tags || [];
    newList = newList.filter((val, i) => {
      return i !== index;
    });

    saveTags(newList);
  };

  function trim(str) {
    if (typeof str === "string") {
      return str.trim()
        .replaceAll(",", "")
        .replaceAll(";", "");
    }
    return str;
  }

  const saveTags = (tags) => {
    // let tg = tags;
    //
    // let res = "";
    //
    // for (let i = 0; i < tg.length; i++) {
    //   res = res + tg[i];
    //
    //   if (tg.length !== 1 && tg.length - 1 !== i) {
    //     res = res + ",";
    //   }
    // }
    props.setTags(tags || []);
  };

  return (
    <Fragment>
      <div
        className={
          props.tags?.length > 0
            ? "tag-input-container d-flex flex-column"
            : "tag-input-container d-flex flex-row"
        }
      >
        <div className="d-flex flex-row flex-wrap">
          {/*<i className="fas fa-tag primary-color tag-icon"></i>*/}

          {props.tags?.length > 0
            ? props.tags.map((tag, index) => (
              <div className="tag" key={index}>
                {tag}&nbsp;
                <i
                  className="fas fa-times ml-1"
                  onClick={e => {
                    removeSelTag(index);
                  }}
                ></i>
              </div>
            ))
            : ""}
        </div>
        <ICInput
          name="title"
          placeholder={props.placeholder || "Press Enter to Add Tag"}
          value={tagInputVal}
          rows={props.rows}
          onChange={handleInputChange}
          onKeyUp={handleOnInputKeyUp}
          onKeyDown={handleOnInputKeyDown}
        />
      </div>
      <span style={{marginTop: "5px", fontSize: "12px", color: "#7d7d7d"}}>
        {tagInputVal !== undefined && tagInputVal.trim().length > 0
          ? (props.label || "Press Enter to Add Tag")
          : ""}
      </span>
    </Fragment>
  );
};

export default ICTagInput;

ICTagInput.propTypes = {
  setTags: PropTypes.func.isRequired,
  tags: PropTypes.array,
  placeholder: PropTypes.string.isRequired,
  maxLength: PropTypes.number
};
